import React, { Component } from 'react'
import Radium from 'radium'
import Link from 'gatsby-link'
import { Helmet } from 'react-helmet'
import Palette from '../components/assets/palette'
import Navbar from '../components/navbar'
import { BTN_STYLES } from '../components/assets/btns-shared'
import MobileContent from '../components/mobile-content'
import Tick from '../components/assets/tick.svg'

const STYLES = {
  pricingContainer: {
    maxWidth: 1440,
    minHeight: 'calc(100vh - 50px)',
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'center',
    flexDirection: 'row',
    margin: '150px auto 0',
    fontSize: 20,
    '@media screen and (max-width: 1000px)': {
      display: 'block'
    }
  },
  priceCard: {
    position: 'relative',
    width: '30%',
    margin: '0 16px',
    backgroundColor: Palette.COAL,
    color: Palette.ROCK,
    borderRadius: 7,
    padding: '10px 31px 27px',
    boxShadow: '0 27px 100px 6px rgba(24,0,8,0.17)',
    '@media screen and (max-width: 1000px)': {
      width: '100%',
      position: 'relative',
      transform: 'none',
      top: 0,
      left: 0,
      margin: '30px auto 0 auto',
      backgroundColor: 'transparent',
      boxShadow: 'none',
      color: Palette.SUNSTONE
    }
  },
  title: {
    fontSize: 28,
    textAlign: 'center',
    width: '100%',
    color: Palette.SUNSTONE,
    marginBottom: -30
  },
  label: {
    textAlign: 'center',
    fontStyle: 'italic',
    marginTop: 12,
    fontSize: 17
  },
  sectionTitle: {
    color: Palette.LIGHT_BLUE,
    fontSize: 18,
  },
  priceSticker: {
    position: 'absolute',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    width: 80,
    height: 80,
    right: -27,
    top: -23,
    fontSize: 28,
    backgroundColor: Palette.LIGHTEST_PINK,
    borderRadius: '50%',
    color: Palette.SUNSTONE,
    '@media screen and (max-width: 1000px)': {
      display: 'none'
    }
  },
  priceStickerLabel: {
    fontSize: 11,
    fontStyle: 'italic',
    textAlign: 'center',
    marginTop: -7
  },
  link: {
    color: Palette.LIGHT_BLUE,
    textDecoration: 'none'
  },
  ul: {
    listStyle: 'none',
    marginLeft: 0,
    marginTop: 35,
    marginBottom: 30,
    paddingLeft: '1em',
    textIndent: '-1em',
    lineHeight: 1.3,
    textAlign: 'left'
  },
  li: {
    paddingLeft: 10,
    fontSize: 18
  },
  btnCTA: {
    display: 'block',
    textAlign: 'center',
    backgroundColor: Palette.LIGHTEST_PINK
  },
  h3: {
    fontSize: 11
  },
  ...BTN_STYLES
}

class Pricing extends Component {

  render() {
    return (
    <div>
      <Helmet>
        <title>Plans & Pricing | Haiku</title>
        <meta name="description" content="Haiku is 100% free to use while we're in Preview. Your projects will always belong to you." />
        <meta property="og:title" content="Plans & Pricing | Haiku" />
        <meta property="og:description" content="Haiku is 100% free to use while we're in Preview. Your projects will always belong to you." />
      </Helmet>

      <Navbar />
      <div style={STYLES.pricingContainer}>
        <div style={STYLES.priceCard}>
          <h1 style={STYLES.title}>Haiku Is Free</h1>
          <ul style={STYLES.ul}>
            <li><img src={Tick} alt="tick" /><span style={STYLES.li}>Unlimited Public Projects on Haiku Cloud (sharing and versioned storage)</span></li>
            <li><img src={Tick} alt="tick" /><span style={STYLES.li}>Project files always available offline</span></li>
            <li><img src={Tick} alt="tick" /><span style={STYLES.li}>Code export (React, Angular, Vue, iOS, Android)</span></li>
            <li><img src={Tick} alt="tick" /><span style={STYLES.li}>GIF export (medium quality)</span></li>
            <li><img src={Tick} alt="tick" /><span style={STYLES.li}>Drawing tool integration (Figma, Sketch, Adobe Illustrator)</span></li>
            <li><img src={Tick} alt="tick" /><span style={STYLES.li}>Open source core (renderer + file format)</span></li>
            <li><img src={Tick} alt="tick" /><span style={STYLES.li}>Required internet connection for app use</span></li>
            <li><img src={Tick} alt="tick" /><span style={STYLES.li}>Publish required for code & GIF exports</span></li>
            <li><img src={Tick} alt="tick" /><span style={STYLES.li}>Invite collaborators to any project (coming soon*)</span></li>
          </ul>
          <a href={`${process.env.ACCOUNT_SITE_URL}/new`}>
            <div key='cta10' style={[STYLES.btn, STYLES.cta, STYLES.btnCTA]}>Get Haiku</div>
          </a>
        </div>

        <div style={STYLES.priceCard}>
          <div style={STYLES.priceSticker}>
            <div>$19</div>
              <div style={STYLES.priceStickerLabel}>/mo*</div>
          </div>
          <h1 style={STYLES.title}>Haiku Pro</h1>
          <ul style={STYLES.ul}>
            <li><img src={Tick} alt="tick" /><span style={STYLES.li}>Includes everything in Haiku Free</span></li>
            <li><img src={Tick} alt="tick" /><span style={STYLES.li}>Unlimited Private & Public Projects on Haiku Cloud (sharing and versioned storage)</span></li>
            <li><img src={Tick} alt="tick" /><span style={STYLES.li}>Full offline support</span></li>
            <li><img src={Tick} alt="tick" /><span style={STYLES.li}>GIF export (high quality)</span></li>
            <li><img src={Tick} alt="tick" /><span style={STYLES.li}>Video export</span></li>
            <li><img src={Tick} alt="tick" /><span style={STYLES.li}>Design + code version control (coming soon)</span></li>
          </ul>
            <a href="https://account.haiku.ai/checkout" key='cta11' style={[STYLES.btn, STYLES.cta, STYLES.btnCTA]}>Go Pro</a>
            <div style={STYLES.label}>*Annual discount available</div>
        </div>

        <div style={STYLES.priceCard}>
          <h1 style={STYLES.title}>Haiku For Teams</h1>
          <ul style={STYLES.ul}>
            <li><img src={Tick} alt="tick" /><span style={STYLES.li}>Includes everything in Haiku Free + Pro</span></li>
            <li><img src={Tick} alt="tick" /><span style={STYLES.li}>Centralized project & access control</span></li>
            <li><img src={Tick} alt="tick" /><span style={STYLES.li}>Real-time collaboration</span></li>
            <li><img src={Tick} alt="tick" /><span style={STYLES.li}>Design + code version control</span></li>
          </ul>
            <div key='cta9' style={[STYLES.btn, STYLES.cta, STYLES.btnCTA]}>
              <a style={{color: Palette.SUNSTONE}} href="mailto:contact@haiku.ai?subject=Enterprise Pricing">Please Contact</a>
            </div>
        </div>
      </div>
      <MobileContent/>
    </div>
    )
  }

}

export default Radium(Pricing)
 


// WEBPACK FOOTER //
// ./src/pages/pricing.js